export class NazioneDTO {
	// public id: string;
	// public nome: string;
	// public codice: string;
	codiceCatastale: string;
	denominazione: string;
	id: string;
	sigla: string;
}